import Environment from "sps-shared/dist/types/enums/Environment";
import getEnvironment from "utils/env/getEnvironment";

export default function isProd(): boolean {
  return getEnvironment() === Environment.Production;
}
